module.exports = __webpack_public_path__ + "img/josla-lv.a81cec94.png";